import { nextTick, onMounted } from 'vue'
import getQueryParam from 'www/utils/get/getQueryParam'
import scrollToElement from 'www/utils/executors/scrollToElement'

const RATE_HASH_RE = /^#rate-(\d+)/

/**
 * Скролл к отзыву после открытия страницы по ссылке.
 *
 * `?rate_id=` ведёт к блоку отзывов целиком:
 * конкретная карточка на главной клиники может быть не в первых видимых.
 * Хеш `#rate-{id}` раскрывает свёрнутый список и скроллит к карточке.
 *
 * На SSR не вешается: нужен `document` и уже смонтированный DOM.
 */
export default function useScrollToReview({
  getReviewIds,
  visibleCount,
  expand,
}: {
  getReviewIds: () => number[]
  visibleCount: number
  expand: () => void
}) {
  if (process.env.IS_SERVER) {
    return
  }

  onMounted(async () => {
    if (getQueryParam('rate_id')) {
      const section = document.querySelector<HTMLElement>('#otzivi')

      if (section) {
        setTimeout(() => scrollToElement(section))
      }

      return
    }

    const [, reviewId] = window.location.hash.match(RATE_HASH_RE) || []

    if (!reviewId) {
      return
    }

    const ids = getReviewIds()
    const index = ids.findIndex(id => String(id) === reviewId)

    if (index >= visibleCount) {
      expand()
      await nextTick()
    }

    const reviewElement = document.querySelector<HTMLElement>(`[data-review-id="${reviewId}"]`)

    if (reviewElement) {
      setTimeout(() => scrollToElement(reviewElement))
    }
  })
}
